import React from 'react'
import './Footer.css'

export default (props) => 
  <div className='Footer'>
    <p>PROAD © 2017/2023 - Todos os direitos reservados</p>
  </div>